import React, { useState } from 'react';
import { Task } from './TaskCard';
import TaskComments from './TaskComments';
import { AuthContext } from '../contexts/AuthContext';
import { useContext } from 'react';

interface Props {
  initialTask?: Task;
  onSave: (task: Task) => void;
  onDelete?: () => void;
  onClose: () => void;
  teamId?: string;
}

const TaskModal: React.FC<Props> = ({ initialTask, onSave, onDelete, onClose, teamId }) => {
  const authCtx=useContext(AuthContext);
  const currentUser=authCtx!.user!;
  const [title, setTitle] = useState(initialTask?.title || '');
  const [description, setDescription] = useState(initialTask?.description || '');
  const [label, setLabel] = useState(initialTask?.label || '');
  const [dueDate, setDueDate] = useState(initialTask?.dueDate || '');
  const [color, setColor] = useState(initialTask?.color || '#6366f1');
  const [priority, setPriority] = useState<'low'|'medium'|'high'>(initialTask?.priority||'medium');

  const handleSave = () => {
    if (!title.trim()) return;
    onSave({ id: initialTask?.id || Date.now().toString(), title: title.trim(), description: description.trim(), label: label.trim(), dueDate, color, priority });
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-md p-6 w-full max-w-sm" onClick={e=>e.stopPropagation()}>
        <h2 className="text-lg font-semibold mb-4">{initialTask?'Edit Task':'Add Task'}</h2>
        <div className="space-y-3 text-sm">
          <div>
            <label className="block mb-1">Title</label>
            <input value={title} onChange={e=>setTitle(e.target.value)} className="w-full border rounded px-3 py-2" />
          </div>
          <div>
            <label className="block mb-1">Description</label>
            <textarea value={description} onChange={e=>setDescription(e.target.value)} rows={3} className="w-full border rounded px-3 py-2" />
          </div>
          <div className="flex gap-2">
            <div className="flex-1">
              <label className="block mb-1">Label</label>
              <input value={label} onChange={e=>setLabel(e.target.value)} className="w-full border rounded px-3 py-2" />
            </div>
            <div className="flex-1">
              <label className="block mb-1">Due Date</label>
              <input type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)} className="w-full border rounded px-3 py-2" />
            </div>
          </div>
          <div>
            <label className="block mb-1">Color</label>
            <input type="color" value={color} onChange={e=>setColor(e.target.value)} className="w-12 h-8 p-0 border rounded" />
          </div>
          <div>
            <label className="block mb-1">Priority</label>
            <select value={priority} onChange={e=>setPriority(e.target.value as any)} className="w-full border rounded px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white">
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
          </div>
        </div>
        {initialTask && teamId && (
          <TaskComments teamId={teamId} taskId={initialTask.id} currentUser={currentUser} />
        )}
        <div className="flex justify-end gap-2 mt-6">
          <button onClick={onClose} className="px-3 py-2 text-gray-600">Cancel</button>
          {onDelete && initialTask && <button onClick={onDelete} className="px-3 py-2 text-red-600">Delete</button>}
          <button onClick={handleSave} className="px-3 py-2 bg-blue-600 text-white rounded disabled:opacity-50" disabled={!title.trim()}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default TaskModal; 